import {
  DirectBillingRxDto,
  DirectBillingSingleRxResponseDto,
  GkvBillEditDto,
  GkvBillEditDtoBillPdf,
  GkvBillEditDtoPaperCenterReceipt,
  GkvBillExportRequestDto,
  GkvBillExportResponseDto,
  GkvBillPrintResponseDto,
  GkvBillUpdateResponseDto,
  MergeDocumentsResponseDto,
  MergedDocumentPayloadDto,
} from "../../../../../../api-client";
import { ValidationMap, ValidationProgress } from "../hooks/useEditValidation";

// Re-export validation types
export type { ValidationMap, ValidationProgress };

// Re-export API types for convenient imports within GKVEdit
export type {
  DirectBillingRxDto,
  DirectBillingSingleRxResponseDto,
  GkvBillEditDto,
  GkvBillEditDtoBillPdf,
  GkvBillEditDtoPaperCenterReceipt,
  GkvBillExportRequestDto,
  GkvBillExportResponseDto,
  GkvBillPrintResponseDto,
  GkvBillUpdateResponseDto,
  MergeDocumentsResponseDto,
  MergedDocumentPayloadDto,
};

// ===========================
// Component Props
// ===========================

export interface GkvEditPageProps {
  billIds: string[];
  onClose: (shouldRefresh?: boolean) => void;
}

export interface GkvEditWorkspaceProps {
  billIds: string[];
  onRowClick: (rx: DirectBillingRxDto) => void;
  onRxDelete: (rxId: string) => void;
  onClose: (shouldRefresh?: boolean) => void;
}

export interface GkvEditBillCardProps {
  bill: GkvBillEditDto;
  selectedRxId: string | null;
  selectedRxIds: Set<string>;
  validationMap: ValidationMap;
  note: string;
  onNoteChange: (value: string) => void;
  onRowClick: (rx: DirectBillingRxDto) => void;
  onMenuOpen: (event: React.MouseEvent<HTMLButtonElement>, rx: DirectBillingRxDto) => void;
  onRemoveAll: (billId: string) => void;
  onTaxieren: (rx: DirectBillingRxDto) => void;
  onToggleRxSelection: (rxId: string) => void;
}

export interface GkvEditBillTableProps {
  rxs: DirectBillingRxDto[];
  selectedRxId: string | null;
  selectedRxIds: Set<string>;
  validationMap: ValidationMap;
  onRowClick: (rx: DirectBillingRxDto) => void;
  onMenuOpen: (event: React.MouseEvent<HTMLButtonElement>, rx: DirectBillingRxDto) => void;
  onTaxieren: (rx: DirectBillingRxDto) => void;
  onToggleRxSelection: (rxId: string) => void;
}

export interface GkvEditHeaderActionsProps {
  activeStep: number;
  isValidating: boolean;
  validationProgress: ValidationProgress;
  testToggleChecked: boolean;
  onAddRx: () => void;
  onTestToggleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export interface GkvEditSummaryProps {
  bills: GkvBillEditDto[];
  validationMap: ValidationMap;
}

// ===========================
// Stepper
// ===========================

export interface StepDef {
  label: string;
  completed: boolean;
}

// ===========================
// Print (Taxieren)
// ===========================

export interface TaxierenPrintData {
  billNumber: string;
  rxNumber: string;
  careProviderIk: string;
  isZahnarzt: boolean;
}

// ===========================
// Test Type (re-defined locally to avoid importing from Edit/)
// ===========================

export enum TestType {
  GLOBAL = "Global",
  INTERNAL = "Internal",
  EXTERNAL = "External",
}

export interface TestTypeData {
  type: TestType;
  email?: string;
}
